<template>
  <div class="hero-section">
    <div class="hero-section__cover-wrapper rounded-t-30">
      <v-img
        class="rounded-t-30"
        :aspect-ratio="isMobile ? 4 / 3 : 3 / 1"
        :src="isMobile ? lpuBranding?.cover_mobile?.url : lpuBranding?.cover_desktop?.url"
        contain
      >
        <template #placeholder>
          <div class="bg-lpu-branding-color-primary h-100" />
        </template>
      </v-img>
      <LpuLogo
        class="hero-section__logo"
        :lpu="lpu"
      />
      <VideoCard
        v-if="lpuVideoCard?.video_path?.url"
        class="hero-section__video-card"
        :video-url="lpuVideoCard.video_path.url"
        :video-uuid="lpuVideoCard.uuid"
      />
    </div>
    <div class="hero-section__info rounded-30">
      <LpuHeadline
        :lpu="lpu"
      />
      <TrustBadges
        :lpu="lpu"
      />
      <div class="d-flex align-center gc-6">
        <RatingCard
          :stars="lpu.stars ?? 0"
          :allrates="lpu.allrates"
        />
        <TownLocation
          :town="lpu.town"
        />
        <LpuMistakeBtn
          v-if="!lpu.closed"
          class="ml-auto"
          :lpu-id="lpu.id"
        />
      </div>
      <LpuType
        :lpu="lpu"
      />

      <div class="hero-section__lpu-info">
        <LpuAddress
          :lpu="lpu"
        />
        <WorkSchedule
          :lpu="lpu"
        />
        <LpuPhone
          :lpu="lpu"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import useIsMobile from 'src/composables/useIsMobile'
import type { Lpu, LpuBranding, LpuVideoCard } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'
import LpuLogo from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuLogo.vue'
import VideoCard from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/VideoCard/VideoCard.vue'
import LpuAddress from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuAddress.vue'
import LpuHeadline from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuHeadline.vue'
import LpuMistakeBtn from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuMistakeBtn.vue'
import LpuPhone from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuPhone.vue'
import LpuType from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuAffiliation.vue'
import RatingCard from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/RatingCard.vue'
import TownLocation from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/TownLocation.vue'
import TrustBadges from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/TrustBadges/TrustBadges.vue'
import WorkSchedule from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/WorkSchedule/WorkSchedule.vue'

defineProps<{
  lpuBranding?: LpuBranding
  lpu: Lpu
  lpuVideoCard?: LpuVideoCard
  synonymPricesCount?: number
}>()

const isMobile = useIsMobile()
</script>

<style lang="scss" scoped>
.hero-section {
  position: relative;
  z-index: 2; /* Нужно, т.к. всплывашки перекрываются элементами */

  &__cover-wrapper {
    margin-bottom: -84px;
    position: relative;
  }

  &__logo {
    position: absolute;
    top: 28px;
    left: 28px;
  }

  &__video-card {
    position: absolute;
    left: 32px;
    bottom: 99px;
  }

  &__info {
    background-color: #F3F6FAE5;
    padding: 32px;
    position: relative;
    row-gap: 16px;
    display: flex;
    flex-direction: column;
    backdrop-filter: blur(17px);
  }

  &__lpu-info {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    column-gap: 16px;
  }
}
</style>
